import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Article} from './article';
import {BaseNumberApi} from '@shared/base/base-number-api';
import {ApiUtils} from '@shared/utils/api.utils';

@Injectable({
  providedIn: 'root'
})
export class ArticleApi extends BaseNumberApi<Article> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, 'articles');
  }

  create(): Article {
    return new Article();
  }

  public toggle(number: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.endpoint}/${number}/toggle`);
  }

  exportArticles() {
    this.httpClient.get(`${this.endpoint}/export`, {
      responseType: 'blob',
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).subscribe({
      next: response => {
        ApiUtils.saveToFileSystem(response);
      }, error: response => {
        console.error(response);
      }
    });
  }

  importArticles(file: File) {
    const form = new FormData();
    form.append('file', file, file.name);

    return this.httpClient.post(`${this.endpoint}/import`, form);
  }
}
